import { $authHost, $host } from "./index";
import axios from "axios";
import {BASE_URL} from "../utils/const";

export const getAllPosts = async (page = 1, category = '', pageSize = '') => {
    const params = {page};
    if (category) params.category = category;
    if (pageSize) params.page_size = pageSize;

    const { data } = await $host.get('post', {params});
    return data;
}

export const dropPost = async (id) => {
    const {data} = await $authHost.delete(`post/${id}`);
    return data;
}

export const storePost = async (header, text, category) => {
    const formData = new FormData();
    const file1 = document.getElementById('image1');
    const file2 = document.getElementById('image2');
    const file3 = document.getElementById('image3');
    if (file1.files[0]) formData.append('image1', file1.files[0]);
    if (file2.files[0]) formData.append('image2', file2.files[0]);
    if (file3.files[0]) formData.append('image3', file3.files[0]);
    formData.append('header', header);
    formData.append('text', text);
    formData.append('category', category);
    await axios.post(BASE_URL + 'post', formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${localStorage.getItem('token')}`,
        },
    })
}

export const editPost = async (id, header, text, category, post) => {
    const formData = new FormData();
    const file1 = document.getElementById('image1');
    const file2 = document.getElementById('image2');
    const file3 = document.getElementById('image3');

    if (file1.files[0]) formData.append('image1', file1.files[0]);
    else formData.append('image1', post.image1 || 0);
    if (file2.files[0]) formData.append('image2', file2.files[0]);
    else formData.append('image2', post.image2 || 0);
    if (file3.files[0]) formData.append('image3', file3.files[0]);
    else formData.append('image3', post.image3 || 0);

    formData.append('header', header);
    formData.append('text', text);
    formData.append('category', category);

    await axios.post(BASE_URL + `post/${id}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${localStorage.getItem('token')}`,
        },
    });
}

export const getLastPost = async () => {
    const {data} = await $host.get('post/last_post');
    return data;
}
